import { Fragment, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
// components
import { Page } from 'theme/elements/Page';
// sections
import CreateMessage from 'components/CreateMessage';
import BeneficiariesDashbaord from 'sections/beneficiary/dashboard';
// reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector, useAppDispatch } from 'hooks/redux.hooks';
import {
	getNonePendingBeneficiaries,
	getLoadingBeneficiaries,
	toggleUpserting,
	getBeneficiaries,
	getMessage,
	setMessage,
} from 'state/reducers/beneficiary.reducers';
//constants
import { pagesEnum, userMessage } from 'constants/ui.constants';
import { loadBeneficiaries } from 'services/beneficiary.services';
import WaitingMessage from 'components/WaitingMessage';
import { getUserPermission } from 'state/reducers/user.reducers';
import _ from 'lodash';
import { UserPermission } from 'constants/user.constants';
import { togglePage } from 'state/reducers/ui.reducers';
import WarningDialog from 'components/WarningDialog';

export default function BeneficiaryApp() {
	const dispatch = useAppDispatch();
	const t = useAppSelector(selectTranslations);
	const navigate = useNavigate();
	const beneficiaries = useAppSelector(getBeneficiaries);
	const loadBeneficiariesState = useAppSelector(getLoadingBeneficiaries);
	const userPermission = useAppSelector(getUserPermission);
	const userMessage: userMessage = useAppSelector(getMessage);

	const openDialog = useMemo(() => {
		return userMessage.exist;
	}, [userMessage]);

	useEffect(() => {
		if (!loadBeneficiariesState.loadingBeneficiaries) {
			dispatch(loadBeneficiaries());
		}
	}, []);

	return (
		<Fragment>
			<WarningDialog
				open={openDialog}
				title={t(userMessage.text || '')}
				subTitle={userMessage.subText}
				handleCancel={() => {
					dispatch(setMessage({ exist: false }));
				}}
			/>
			{loadBeneficiariesState.startLoadingBeneficiaries && !loadBeneficiariesState.loadingBeneficiaries ? (
				<Page>
					<Fragment>
						{beneficiaries.length ? (
							<BeneficiariesDashbaord beneficiaries={beneficiaries} />
						) : (
							<CreateMessage
								title={t('page.beneficiary.create.blank_page.title')}
								text={t('page.beneficiary.create.blank_page.text')}
								addLabel={t('page.beneficiary.create.blank_page.add_button.text')}
								imageKey={'page.beneficiary.create.blank_page.icon'}
								onclick={() => {
									dispatch(toggleUpserting(true));
									dispatch(togglePage(`/${pagesEnum.BENEFICIARY}/new`));
								}}
								noAction={
									!_.includes([UserPermission.OPERATIONER, UserPermission.SIGNER], userPermission)
								}
							/>
						)}
					</Fragment>
				</Page>
			) : (
				<WaitingMessage title="getting there..." imageKey="page.beneficiary.loading.icon" />
			)}
		</Fragment>
	);
}
